import React from 'react';
import { Reveal } from './Reveal';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  tone?: 'dark' | 'light';
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  tone = 'dark'
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return <Reveal className={`max-w-2xl ${isCenter ? 'mx-auto text-center' : ''}`} data-id="element-322" data-mp="rzu8px5v1bh5">
      {eyebrow && <div className={`flex items-center gap-4 ${isCenter ? 'justify-center' : ''}`} data-id="element-323" data-mp="n0rbgyw4g9jq">
          <span className="rule-gold" aria-hidden="true" data-id="element-324" data-mp="i6n3ccb4dvh2" />
          <p className="eyebrow text-gold-dark" data-id="element-325" data-mp="d83gm9opcfnn">{eyebrow}</p>
        </div>}
      <h2 className={`mt-5 font-display text-3xl font-medium leading-[1.15] sm:text-4xl lg:text-[2.75rem] ${tone === 'dark' ? 'text-navy' : 'text-white'}`} data-id="element-326" data-mp="8aaf3tycg9tp">
        {title}
      </h2>
      {description && <p className={`mt-5 text-base leading-relaxed ${tone === 'dark' ? 'text-charcoal-light' : 'text-navy-100/70'}`} data-id="element-327" data-mp="3vf00jwzfqi75">
          {description}
        </p>}
    </Reveal>;
}